import { Environment } from "./environment.interface";

export const environment: Environment = {
	build: {
		adminRoute: "my-club/sufc", // slugged base; updated at runtime from the club's real slug (ClubContext)
		appleStoreLink: "https://www.apple.com/uk/app-store/",
		visitorRoute: "visitor",
		companyCommonName: "HomecookedUK",
		companyLongName: "HomecookedUK",
		companyShortName: "Homecooked",
		customerRoute: "app",
		googlePlayLink: "https://play.google.com/store/games",
		production: false,
		scoreboardRoute: "scoreboard"
	},
	externalAPIs: {
		facebook: {
			appId: "332811618924057"
		},
		firebase: {
			appId: "1:1022590818121:android:5b701cc6844eb44af2ec98",
			projectId: "framework-5b301"
		},
		getAddress: {
			key: "bq5dGZGH3EiRyFy-GnXQKQ12710"
		},
		google: {
			clientId: "1022590818121-goo89n5lph2omnlkql7qcqcq8e40eoms.apps.googleusercontent.com"
		},
		mapbox: {
			apiKey: "pk.eyJ1IjoiZGVidWdsYWJzdWsiLCJhIjoiY2t6eW9td3Q0MDF5dzNpbmFha3N2OG1rbiJ9.9mt4Fkj72HYpHMnCUBfvjQ",
			style: "mapbox://styles/debuglabsuk/cl38v927m000i14qlj5xf8sc7/draft"
		},
		photoroom: {
			apiKey: "722604a79cbb99e3b2b49c223df6e0e77b45c43c",
			url: "https://sdk.photoroom.com/v1/segment"
		},
		sendGrid: {
			api: "",
			clientId: "",
			secret: "",
			username: ""
		},
		stripe: {
			key: "pk_test_osSfKG5kUVdhyfh3mSyT3ezJ"
		},
		apiFootball:{
			url:"https://api-football-v1.p.rapidapi.com/v3",
			apiKey:"1b9a948b6emsha7b9c12b7457094p155f8djsn677ed2ead241",
			leagues: [39,40,43]
		}
	},
	server: {
		accessTokenExpiryMilliseconds: 14400000, // 4h - matches API JWT TokenValidityInMinutes
		accessTokenRefreshMilliseconds: 12600000, // refresh at 3.5h, comfortably before expiry
		//apiURL: "https://localhost:53549", // local api
		//apiURL: "https://sufc-api.azurewebsites.net", // azure direct
		apiURL: "https://api.thepitchbase.app",
		storageUrl: "https://sufc.blob.core.windows.net/uploads"
	}
}